import type { ReactNode } from 'react';
import { Spinner } from '@/components/ui/Spinner';
import { Pagination } from '@/components/ui/Pagination';
import { cn } from '@/lib/cn';

type PaginatedTableProps = {
  loading: boolean;
  error?: string | null;
  pageIndex: number;
  hasNext: boolean;
  hasPrev: boolean;
  onNext: () => void;
  onPrev: () => void;
  pageSize?: number;
  onPageSizeChange?: (size: number) => void;
  empty?: ReactNode;
  children: ReactNode;
  className?: string;
};

export function PaginatedTable({
  loading,
  error,
  pageIndex,
  hasNext,
  hasPrev,
  onNext,
  onPrev,
  pageSize,
  onPageSizeChange,
  empty,
  children,
  className
}: PaginatedTableProps) {
  return (
    <div className={cn('relative overflow-x-auto rounded-lg border border-[var(--fv-border)]', className)}>
      {loading && (
        <div
          className="absolute inset-0 z-10 flex items-center justify-center bg-[var(--fv-surface)]/70"
          aria-busy="true"
        >
          <Spinner size="md" />
        </div>
      )}
      {children}
      {!loading && error && (
        <p className="px-3 py-2 text-sm text-red-600">{error}</p>
      )}
      {!loading && !error && empty}
      <Pagination
        pageIndex={pageIndex}
        hasNext={hasNext}
        hasPrev={hasPrev}
        onNext={onNext}
        onPrev={onPrev}
        loading={loading}
        pageSize={pageSize}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  );
}
